import { defineEffect } from '../../../core/effect';
import { battleSpec } from '../fx/battle';

/** ダメージ計算（モンスターとぶつかる）（Issue #589。状況は共通側の `editorPorts/duelSituations/battle.js` が決め、絵の組み立ては `../fx/battle.js`） */
export default defineEffect({ situation: 'battle_monster', role: 'motion', ...battleSpec(false) }, 'battle_monster_motion.js');
